export const DRAGGABLE_ID = {
  COLUMN: "COLUMN",
  WELL_ITEM: "WELL_ITEM",
};

export const DROPPABLE_ID = {
  CANVAS_MAIN: "CANVAS_MAIN",

  X_AXIS_WELL: "X_AXIS_WELL",
  Y_AXIS_WELL: "Y_AXIS_WELL",

  PIE_METRIC: "PIE_METRIC_WELL",
  PIE_DIMENSION: "PIE_DIMENSION_WELL",

  SCATTER_BUBBLE_SIZE_WELL: "SCATTER_BUBBLE_SIZE_WELL",
};
